<template>
	<div class="">
		<ImputSearch
			v-model="query"
			class="flex gap-4"
		/>
		<div class="flex flex-col p-1 overflow-hidden gap-1">
			<span
				v-for="estrato in orderedData"
				:key="estrato.id"
				:class="value.includes(estrato.id) ? '' : 'opacity-40'"
				class="text-xs hover:bg-[#E6E6E6] px-2 py-1 rounded cursor-pointer flex items-center gap-2"
				@click="manageEstratoEscolhido(estrato.id)"
			>
				<span
					class="h-2 !max-w-[16px] !min-w-[16px] flex rounded"
					:style="{ backgroundColor: estrato.color }"
				/>
				<p class="!m-0 text-xs text-[#01395E] font-semibold text-elipsis">
					{{ estrato.descricao }}
				</p>
			</span>
		</div>
		<div class="flex items-center justify-between px-4">
			<span @click="prev">
				<Icon
					icon="bxs:up-arrow"
					:rotate="3"
					class="cursor-pointer"
				/>
			</span>
			<p
				class="!m-0"
				@click="next"
			>
				{{ `${currentPage}/${pageCount}` }}
			</p>
			<span @click="next">
				<Icon
					icon="bxs:up-arrow"
					:rotate="1"
					class="cursor-pointer"
				/>
			</span>
		</div>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import { useOffsetPagination } from '@vueuse/core'

import ImputSearch from '../InputSearch/InputSearch.vue'

import { computed, ref } from 'vue'

const props = defineProps({
	data: { type: Array, required: true },
	value: { type: Array, required: true },
})

const { currentPage, currentPageSize, pageCount, prev, next } = useOffsetPagination({
	total: props.data.length,
	page: 1,
	pageSize: 10,
})

const query = ref('')

const orderedData = computed(() => {
	const selecionados = props.data.filter((f) => props.value.includes(f.id))
	const outros = props.data
		.filter((f) => !props.value.includes(f.id))
		.filter((f) => f.descricao.toLowerCase().includes(query.value.toLowerCase()))
	return [...selecionados, ...outros].slice(start.value, end.value)
})

const start = computed(() => (currentPage.value - 1) * currentPageSize.value)

const end = computed(() => start.value + currentPageSize.value)

const manageEstratoEscolhido = (id) => {
	if (props.value.includes(id)) {
		const index = props.value.findIndex((f) => f === id)
		props.value.splice(index, 1)
	} else {
		props.value.push(id)
	}
}
</script>
